import React, { useRef, useState,useEffect } from "react";
import { useFormik } from "formik";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Divider } from "primereact/divider";
import { classNames } from "primereact/utils";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { formatMoney } from "../../shared/utilitties/formatMoney";
import { ComprobanteFileUpload } from "./ComprobantesFileUpload";
import {
  actualizarFacturaPresentacion,
  crearFacturaPresentacionOCR,
  leerFacturaPresentacionOCR,
  ObtenerDetalleIIBBPercepcionescomercioconfig,
  ObtenerListadoJurisdiccion,
} from "../services/facturas.service";
import { FacturasIngresadaDTO, FacturasIngresadaOCRDTO } from "../adapters/factura.adapter";
import { FacturaImagenDTO, FacturaImagenOCRDTO } from "../adapters/facturaImagen.adapter";
import { InputNumber } from "primereact/inputnumber";
//context
import { usePresentacionContext } from "../context/presentacion.context";
//constants
import {
  FAILED_VALIDATION,
  LIFE_TOAST_MESSAGE,
  REGEX,
  SUCCESS_VALIDATION,
} from "../utilities/constants";
import {
  TOLERANCIA_DIF_IVA_PERCEPCION,
} from "../utilities/constantsImpuestos";
// css
import "./ComprobantesForm.css";
import { isCombustibleAfines } from "../utilities/utils";
import { HttpStatusCode } from "axios";
import { ParametroDTO } from "../models/parametros.model";
import '../../shared/styles/datePicker.scss'
import { ComprobantesModalPreValidacionesOCR } from "./ComprobantesModalPreValidacionesOCR";
import ScanOCR_ERROR from "../../../images/SCAN_ERROR.png";
import ScanOCR from "../../../images/data_scan.png";
import { INICIADA_COMERCIO, RECHAZADA,INGRESADO, GENERADO ,PAGADO ,TRANSFERIDO } from "../utilities/constants";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const ENTER_KEY = "Enter";

interface Props {
  onHide: Function;
}
interface IngresoJurisdiccion {
  jurisdiccion: any; 
  monto: number;
}
export const ComprobantesFormOCR = (props: Props) => {
  const {
    presentacion,
    comprobanteSeleccionado,
    file,
    tasasIVA,
    tasaIvaSelected,
    tiposFactura,
    updateComprobantes,
    setUpdateComprobantes,
    fileName,
    setFileName,
    setFile,
    setMessage,
    setImageComprobante,
    presentacionEditable,
    selectedProductoComercio,
    parametrosPresentacion,
    presentacionState,
    ingresoManual,
    setIngresoManual,
    seteditarOCR,
    editarOCR,
    setmostrarFormComprobante,
    mostrarFormComprobante
  } = usePresentacionContext();
  const [spinnerGuardarComprobante, setSpinnerGuardarComprobante] =
    useState(false);
  const [mostrarCargaComprobante, setmostrarCargaComprobante] =
    useState(false);
const [collapsedIngresosBrutos, setCollapsedIngresosBrutos] = useState(true);

  // const [mostrarFormComprobante, setmostrarFormComprobante] = useState(false);
  const [lecturaOCR, setLecturaOCR] = useState<'success' | 'warning' | 'error' | null>(null);
  // const [ingresoManual, setIngresoManual] = useState(false);
  const [esFAC, setesFAC] = useState(false);
  const [sinCAE, setsinCAE] = useState(false);
  const [observacionesOCR, setobservacionesOCR] = useState("");
  const [lecturaDataOCR, setlecturaDataOCR] = useState<any | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [mensaje, setMensaje] = useState<any | null>(null);

  const toast = useRef<Toast>(null);

   // Estados
       const [jurisdiccionesConfig, setjurisdiccionesConfig] = useState<any[]>([]);
      const [jurisdicciones, setJurisdicciones] = useState<any[]>([]);
      const [selectedJurisdiccion, setSelectedJurisdiccion] = useState<any | null>(null);
      const [montoJurisdiccion, setMontoJurisdiccion] = useState<number | null>(null);
      const [ingresosJurisdicciones, setIngresosJurisdicciones] = useState<IngresoJurisdiccion[]>([]);
    const [editingRowIndex, setEditingRowIndex] = useState<number | null>(null);
      const [editingMonto, setEditingMonto] = useState<string>('');
    
      // Cargar jurisdicciones 
      useEffect(() => {
          fetchJurisdicciones();
        }, []);
  
          useEffect(() => {
            if( JSON.stringify(comprobanteSeleccionado) === "{}"){
              detalleIIBBPercepcionescomercioconfig();
            }
          }, [jurisdicciones]);

        useEffect(() => {
          if (comprobanteSeleccionado?.detalleIIBBPercepciones && 
              comprobanteSeleccionado.detalleIIBBPercepciones.length > 0 &&
              jurisdicciones.length > 0) {
            
            const jurisdiccionesTransformadas = comprobanteSeleccionado.detalleIIBBPercepciones.map((item: { sta_code: any; sta_label: any; fpd_IIBB_percepcion: any; }) => {
              // Buscar la jurisdicción completa en la lista
            const jurisdiccionCompleta = jurisdicciones.find(
              (j: { codigo: any; }) => j.codigo === parseInt(item.sta_code)
            );
              
              return {
                jurisdiccion: jurisdiccionCompleta || {
                  codigo: item.sta_code,
                  descripcion: item.sta_label
                },
                monto: item.fpd_IIBB_percepcion
              };
            });
            
            setIngresosJurisdicciones(jurisdiccionesTransformadas);
          }
        }, [comprobanteSeleccionado, jurisdicciones]);
  
      const fetchJurisdicciones = async () => {
        try {
          const response = await ObtenerListadoJurisdiccion(); 
          setJurisdicciones(response.data.jurisdicciones);
        } catch (error) {
          console.error('Error al cargar jurisdicciones', error);
        }
      };
  
      const detalleIIBBPercepcionescomercioconfig = async () => {
        try {
          const response = await ObtenerDetalleIIBBPercepcionescomercioconfig(); 
          const jurisdiccionesConfig = response.data.jurisdiccionesConfig;
          setjurisdiccionesConfig(jurisdiccionesConfig);
          
        } catch (error) {
          console.error('Error al cargar jurisdicciones config', error);
        }
      };

      // Agregar jurisdicción
      const handleAgregarJurisdiccion = () => {
      if (!selectedJurisdiccion || !montoJurisdiccion) {
        // Mostrar mensaje de error
        return;
      }
      
      // Buscar si la jurisdicción ya existe
      const indiceExistente = ingresosJurisdicciones.findIndex(
        item => item.jurisdiccion.descripcion === selectedJurisdiccion.descripcion
      );
      
      let nuevosIngresos;
      
      if (indiceExistente !== -1) {
        // Si existe, reemplazar el monto
        nuevosIngresos = [...ingresosJurisdicciones];
        nuevosIngresos[indiceExistente] = {
          jurisdiccion: selectedJurisdiccion,
          monto: montoJurisdiccion
        };
      } else {
        // Si no existe, agregar nueva
        const nueva = {
          jurisdiccion: selectedJurisdiccion,
          monto: montoJurisdiccion
        };
        nuevosIngresos = [...ingresosJurisdicciones, nueva];
      }
      
      setIngresosJurisdicciones(nuevosIngresos);
      
      // Actualizar Formik con el nuevo total (recalcular desde cero)
      const nuevoTotal = nuevosIngresos.reduce((sum, item) => sum + item.monto, 0);
      formik.setFieldValue('Fac_IIBB_percepcion', nuevoTotal);
        
      setSelectedJurisdiccion(null);
      setMontoJurisdiccion(null);
  };
    // Eliminar jurisdicción
    const handleEliminarJurisdiccion = (index: any) => {
      const nuevos = ingresosJurisdicciones.filter((_, i) => i !== index);
      setIngresosJurisdicciones(nuevos);
      
      // Actualizar Formik con el nuevo total
      const nuevoTotal = nuevos.reduce((sum, item) => sum + item.monto, 0);
      formik.setFieldValue('Fac_IIBB_percepcion', nuevoTotal);
    };
  
    // Calcular total (mantener esta función para mostrar)
    const calcularTotal = () => {
      return ingresosJurisdicciones.reduce((sum, item) => sum + item.monto, 0);
    };

  // useEffect para rotar los mensajes
  useEffect(() => {
    if (!mostrarCargaComprobante) return;

    const intervalo = setInterval(() => {
      setMensajeActualIndex((prevIndex) => (prevIndex + 1) % mensajesOCR.length);
    }, 2500);

    return () => clearInterval(intervalo);
  }, [mostrarCargaComprobante]);

   const buttonsBodyTemplate = (rowIndex: number) => {
        const isEditing = editingRowIndex === rowIndex;
        
       return (
               <React.Fragment>
               <span className="p-column-title">Acciones</span>
               
               {isEditing ? (
                 <>
                   <Button
                     icon="pi pi-check"
                     onClick={() => handleSaveMonto(rowIndex)}
                     tooltip="Guardar"
                     tooltipOptions={{ position: 'top' }}
                     style={{
                       background: 'none',
                       border: 'none',
                       color: 'inherit',
                       padding: '0.5rem',
                       boxShadow: 'none'
                     }}
                     type="button"
                   />
                   <Button
                     icon="pi pi-times"
                     onClick={handleCancelEdit}
                     tooltip="Cancelar"
                     tooltipOptions={{ position: 'top' }}
                     style={{
                       background: 'none',
                       border: 'none',
                       color: 'inherit',
                       padding: '0.5rem',
                       boxShadow: 'none'
                     }}
                     type="button"
                   />
                 </>
               ) : (
                 <>
                   <Button
                     icon="pi pi-pencil"
                     onClick={() => onClickEditIIBB(rowIndex)}
                     tooltip="Editar"
                     tooltipOptions={{ position: 'top' }}
                     style={{
                       background: 'none',
                       border: 'none',
                       color: 'inherit',
                       padding: '0.5rem',
                       boxShadow: 'none'
                     }}
                     type="button"
                   />
                   <Button
                     icon="pi pi-trash"
                     onClick={() => handleEliminarJurisdiccion(rowIndex)}
                     tooltip="Eliminar"
                     tooltipOptions={{ position: 'top' }}
                     style={{
                       background: 'none',
                       border: 'none',
                       color: 'inherit',
                       padding: '0.5rem',
                       boxShadow: 'none'
                     }}
                     type="button"
                   />
                 </>
               )}
             </React.Fragment>
             );
      };
  
      const montoBodyTemplate = (rowData: any, props: any) => {
        const rowIndex = props.rowIndex;
        
        if (editingRowIndex === rowIndex) {
          return (
            <div className="p-inputgroup" style={{ justifyContent: 'flex-end' }}>
              <InputNumber
                value={parseFloat(editingMonto) || 0}
                onValueChange={(e) => setEditingMonto(e.value?.toString() || '0')}
                mode="currency"
                currency="ARS"
                locale="es-AR"
                minFractionDigits={2}
                maxFractionDigits={2}
                className="p-inputtext-sm"
                style={{ textAlign: 'right', width: '100%' }}
                autoFocus
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleSaveMonto(rowIndex);
                  } else if (e.key === 'Escape') {
                    handleCancelEdit();
                  }
                }}
              />
            </div>
          );
        }
        
        return (
          <span>
          $ {(rowData.monto || 0).toLocaleString('es-AR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}
        </span>
        );
      };
  
      const onClickEditIIBB = (rowIndex: number) => {
        setEditingRowIndex(rowIndex);
        const currentMonto = ingresosJurisdicciones[rowIndex].monto;
        setEditingMonto(currentMonto.toString());
      };
  
      // Función para guardar los cambios del monto editado
      const handleSaveMonto = (rowIndex: number) => {
        const nuevoMonto = parseFloat(editingMonto);
        
        if (isNaN(nuevoMonto) || nuevoMonto < 0) {
          toast.current?.show({
            severity: 'error',
            summary: 'Error',
            detail: 'El monto debe ser un número válido',
            life: 3000
          });
          return;
        }
  
        // Actualizar el array de ingresos jurisdicciones
        const nuevosIngresos = [...ingresosJurisdicciones];
        nuevosIngresos[rowIndex] = {
          ...nuevosIngresos[rowIndex],
          monto: nuevoMonto
        };
        
        setIngresosJurisdicciones(nuevosIngresos);
        
        // Recalcular el total y actualizar Formik
        const nuevoTotal = nuevosIngresos.reduce((sum, item) => sum + item.monto, 0);
        formik.setFieldValue('Fac_IIBB_percepcion', nuevoTotal);
  
        // Salir del modo edición
        setEditingRowIndex(null);
        setEditingMonto('');
        
        toast.current?.show({
          severity: 'success',
          summary: 'Éxito',
          detail: 'Monto actualizado correctamente',
          life: 3000
        });
      };
  
      // Función para cancelar la edición
      const handleCancelEdit = () => {
        setEditingRowIndex(null);
        setEditingMonto('');
      };

  const compRefs = {
    tipoFactura: useRef<Dropdown>(null),
    puntoVenta: useRef<HTMLInputElement>(null),
    numero: useRef<HTMLInputElement>(null),
    fecha: useRef<HTMLInputElement>(null),
    neto: useRef<HTMLInputElement>(null),
    tasas: useRef<HTMLInputElement>(null),
    iva_inp: useRef<HTMLInputElement>(null),
    iva_perc: useRef<HTMLInputElement>(null),
    ibb: useRef<HTMLInputElement>(null),
    total: useRef<HTMLInputElement>(null),
    iva_dropdw: useRef<Dropdown>(null)
  };
  const tasaIvaFilter =
    JSON.stringify(comprobanteSeleccionado) !== "{}"
      ? tasasIVA.filter(
        (item: any) => item.tasa == comprobanteSeleccionado.fac_tasa_iva
      )
      : [];
  const tiposFacturaFilter =
    JSON.stringify(comprobanteSeleccionado) !== "{}"
      ? tiposFactura.filter(
        (item: any) =>
          item.fat_descripcion_corta ===
          comprobanteSeleccionado.fat_descripcion_red
      )
      : [];
  const formik = useFormik({
    initialValues: {
      fat_descripcion_red:
        tiposFacturaFilter.length > 0 ? tiposFacturaFilter[0] : [],
      fac_tipo_comprobante:
        JSON.stringify(comprobanteSeleccionado) !== "{}"
          ? comprobanteSeleccionado.fac_tipo_comprobante
          : tasasIVA[0].tipo_comprobante!= "N" ? tasasIVA[0].tipo_comprobante : "A",
      Fac_sucursal: comprobanteSeleccionado.fac_sucursal,
      Fac_numero: comprobanteSeleccionado.fac_numero,
      Fecha:
        comprobanteSeleccionado.fac_fecha &&
        new Date(comprobanteSeleccionado.fac_fecha),
      Fac_neto:
        comprobanteSeleccionado.fac_neto ?
          parseFloat(comprobanteSeleccionado.fac_neto) : 0,
      Fac_impuestos:
        comprobanteSeleccionado.fac_impuestos ?
          parseFloat(comprobanteSeleccionado.fac_impuestos) : 0,
      Fac_iva:
        comprobanteSeleccionado.fac_iva ?
          parseFloat(comprobanteSeleccionado.fac_iva) : 0,
      Fac_iva_percepcion:
        comprobanteSeleccionado.fac_iva_percepcion ?
          parseFloat(comprobanteSeleccionado.fac_iva_percepcion) : 0,
      Fac_IIBB_percepcion:
        comprobanteSeleccionado.fac_IIBB_percepcion ?
          parseFloat(comprobanteSeleccionado.fac_IIBB_percepcion) : 0,
      Fac_total:
        comprobanteSeleccionado.fac_total ?
          parseFloat(comprobanteSeleccionado.fac_total) : 0,
      Fac_tasa_iva: tasaIvaFilter.length > 0 ? tasaIvaFilter[0] : [],
    },
    validate: (data) => {
       let errors: any = {};
    
    if (data.fat_descripcion_red.length === 0) {
        errors.fat_descripcion_red = "Requerido.";
      }
      if (!data.fac_tipo_comprobante) {
        errors.comprobante = "Requerido.";
      }
      if (!data.Fac_sucursal) {
        errors.Fac_sucursal = "Requerido.";
      }
      if (!data.Fac_numero) {
        errors.Fac_numero = "Requerido.";
      }
      if (data.Fac_neto == 0 || data.Fac_neto == null) {
        errors.Fac_neto = "Requerido.";
      }
      if (data.Fac_impuestos !== 0) {
        if (!data.Fac_impuestos) {
          errors.Fac_impuestos = "Requerido.";
        }
      }
      if (data.Fac_iva !== 0) {
        if (!data.Fac_iva) {
          errors.Fac_iva = "Requerido.";
        }
      }
      if (data.Fac_total == 0 || data.Fac_total == null) {
        errors.Fac_total = "Requerido.";
      }
      if (data.Fac_tasa_iva.length === 0) {
        errors.Fac_tasa_iva = "Requerido.";
      }
      if (new Date(data.Fecha).setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0)) {
        errors.Fecha = "No puede ser futura.";
      }
      return errors;
    },
    onSubmit: async (formData: any) => {
      const percepcionesFormateadas = ingresosJurisdicciones.map(ingreso => ({
        Fpa_id: comprobanteSeleccionado.fac_id? comprobanteSeleccionado.fac_id:  null,
        Fpd_IIBB_percepcion: ingreso.monto,
        sta_code: ingreso.jurisdiccion.codigo,
        fechadesde: ingreso.jurisdiccion.fecdesde,
        fechahasta: ingreso.jurisdiccion.fechasta,
        descripcion: ingreso.jurisdiccion.descripcion,
      }));
      const resultValidaciones = ComprobantesValidacionesOCR(formData,null,percepcionesFormateadas);
      if (resultValidaciones.message === FAILED_VALIDATION) return;
       let ocrData = {
      documentID:lecturaDataOCR?.idDocumentData,
      ingresoManual:ingresoManual,
      observaciones:observacionesOCR
    }

     
    let facturasIngresadaDTO = FacturasIngresadaOCRDTO(formik.values, presentacion,ocrData);
    let facturaImagenDto = FacturaImagenDTO();
    let facturasPresentacionRequest = {
      factura: facturasIngresadaDTO,
      imagenFactura: facturaImagenDto,
        percepciones: percepcionesFormateadas
    };

    if (fileName && file) {
      let fileBase64 = file?.replace(REGEX, "");
      let facturaImagenDto = FacturaImagenDTO(fileName, fileBase64);
      facturasPresentacionRequest.imagenFactura = facturaImagenDto;
    }
    setSpinnerGuardarComprobante(true);
    if (JSON.stringify(comprobanteSeleccionado) === "{}") {
    const { data, status } = await crearFacturaPresentacionOCR(facturasPresentacionRequest);

    if (typeof data === 'string') {
      const match = data.match(/Your support ID is ([a-z0-9-]+)/i);
      const supportId = match ? match[1] : "id-desconocido";
          toast.current?.show({
            life: LIFE_TOAST_MESSAGE,
            severity: "error",
            summary: "Error del Sistema",
            detail: data.includes('Request Rejected') 
              ? "El documento no cumple con nuestras políticas de seguridad, prueba con otro formato o contacta al SAC con el código: " +supportId
              : "Ocurrió un error en la lectura, vuelva a intentar más tarde.",
          });
      setSpinnerGuardarComprobante(false);
      return { message: FAILED_VALIDATION };
    }

    if (status != HttpStatusCode.Ok) {
      toast.current?.show({
        life: LIFE_TOAST_MESSAGE,
        severity: status == HttpStatusCode.InternalServerError ? "error" : "warn",
        summary: "Mensaje",
        detail: data.message != null && data.message != '' ? data.message : "Hubo un error al crear el comprobante",
      });

      setSpinnerGuardarComprobante(false);
      return { message: FAILED_VALIDATION };
    }

    setMessage({
      life: 5000,
      severity: "success",
      summary: "Mensaje",
      detail: "Comprobante registrado.",
    });
    setUpdateComprobantes(updateComprobantes + 1);
  } else {
          facturasPresentacionRequest.factura.Fac_id =comprobanteSeleccionado.fac_id;
          facturasPresentacionRequest.factura.Fpa_nombre_imagen =comprobanteSeleccionado.fpa_nombre_imagen;
  
          const {data, status} = await actualizarFacturaPresentacion(facturasPresentacionRequest);
           if (typeof data === 'string') {
          const match = data.match(/Your support ID is ([a-z0-9-]+)/i);
          const supportId = match ? match[1] : "id-desconocido";
              toast.current?.show({
                life: LIFE_TOAST_MESSAGE,
                severity: "error",
                summary: "Error del Sistema",
                detail: data.includes('Request Rejected') 
                  ? "El documento no cumple con nuestras políticas de seguridad, prueba con otro formato o contacta al SAC con el código: " +supportId
                  : "Ocurrió un error en la lectura, vuelva a intentar más tarde.",
              });
                setSpinnerGuardarComprobante(false);
                return { message: FAILED_VALIDATION };
              }
          let msgUpd: string = ''
          if(status == HttpStatusCode.Ok){
            msgUpd= "Comprobante actualizado" 
          }
          else if(data.message != null && data.message != ''){
            data.message.indexOf('Cannot insert duplicate key') > 0 
            ? msgUpd = "El comprobante ya se encuentra cargado para ese comercio."
            : msgUpd ="Hubo un error al actualizar.";
          }else {
            msgUpd ="Hubo un error al actualizar.";
          } 
          setMessage({
            life: 5000,
            severity: status == HttpStatusCode.Ok ? "success" : "error",
            summary: "Mensaje",
            detail:  msgUpd
          });
          setUpdateComprobantes(updateComprobantes + 1)
        }
    setSpinnerGuardarComprobante(false);
    onHideDialog();
    },
  });

  const formikTouched: any = formik.touched;
  const formikErrors: any = formik.errors;

  const isFormFieldValid = (name: string) =>
    !!(formikTouched[name] && formikErrors[name]);
  const getFormErrorMessage = (name: string) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formikErrors[name]}</small>
      )
    );
  };
  const onHideDialog = () => {
    setFileName("");
    formik.resetForm();
    setImageComprobante({});
    props.onHide();
    //setFile()
  };
  const handlerEnterKey: (event: { key: string, preventDefault: () => any, stopPropagation: () => any }, submit: boolean, next: React.RefObject<HTMLInputElement | Dropdown> | null) => void = (e, submit, next) => {
    if (e.key !== ENTER_KEY) return;

    if (submit) {
      e.stopPropagation();
      formik.handleSubmit();
      return;
    }

    if (next == null || next.current == null) return;

    e.preventDefault();
    e.stopPropagation();

    if(next.current instanceof HTMLInputElement) {
      next.current.focus();
      return;
    }

    next.current.getFocusInput().focus();
  }
  const subtitleCard = (subtitle: string) => {
    return <span style={{ fontWeight: 600 }}>{subtitle}</span>;
  };

  const [mensajeActualIndex, setMensajeActualIndex] = useState(0);

  const mensajesOCR = [
    'Por favor aguarda mientras DataScan hace su trabajo…',
    'DataScan está detectando valores y conceptos declarados…',
    'DataScan está interpretando declaraciones de impuestos…',
    'DataScan intenta validar los datos leídos…'
  ];

  const LeerFacturaPresentacion = async () => {
    let facturaImagenDto = FacturaImagenOCRDTO();
    if (fileName && file) {
      let fileBase64 = file?.replace(REGEX, "");
      facturaImagenDto = FacturaImagenOCRDTO(fileName, fileBase64, presentacion);
    }
    setMensajeActualIndex(0);
    setmostrarCargaComprobante(true);
    if (JSON.stringify(comprobanteSeleccionado) === "{}") {
      const { data, status } = await leerFacturaPresentacionOCR(facturaImagenDto);
      setmostrarCargaComprobante(false);

      if (typeof data === 'string') {
          const match = data.match(/Your support ID is ([a-z0-9-]+)/i);
          const supportId = match ? match[1] : "id-desconocido";
              toast.current?.show({
                life: LIFE_TOAST_MESSAGE,
                severity: "error",
                summary: "Error del Sistema",
                detail: data.includes('Request Rejected') 
                  ? "El documento no cumple con nuestras políticas de seguridad, prueba con otro formato o contacta al SAC con el código: " +supportId
                  : "Ocurrió un error en la lectura, vuelva a intentar más tarde.",
              });
      setLecturaOCR('error');
      setiibbconfig();
      setFile(null);
      setFileName(null);
      setmostrarFormComprobante(false);
      setIngresoManual(false);
      return;
    }

      if (status != HttpStatusCode.Ok) {
        if(data.message != null && data.message != ''){
            setMensaje(data.message + ". Elegí cómo seguir:");
        }else{
            setMensaje("Hubo un error al leer el comprobante. Elegí cómo seguir:");
        }
        setModalOpen(true);
        setmostrarCargaComprobante(false);
        setLecturaOCR('error');
        setiibbconfig();
        return;
      }
      setlecturaDataOCR(data);
      let fac_ocr = MapeoFactura_Ocr(data);
      // carga de iibb
      let iibb = agregarIIBBporJuridisccion(data);
      fac_ocr.Fac_IIBB_percepcion = iibb;
      const erroresOCR = validateFacturaData(fac_ocr);
      const tieneErrores = Object.keys(erroresOCR).length > 0;

      formik.resetForm({ 
        values: fac_ocr,
        errors: tieneErrores ? erroresOCR : {},
        touched: tieneErrores 
          ? Object.keys(erroresOCR).reduce((acc, key) => ({ ...acc, [key]: true }), {})
          : {}
      });
      const prevalidaciones = ComprobantesPreValidacionesOCR(data,fac_ocr);
      if (prevalidaciones.listErrores.length > 0) {
        setMensaje(prevalidaciones.listErrores);
        setModalOpen(true); 
        setLecturaOCR('warning');
        return;
      }

      const resultValidaciones = ComprobantesValidacionesOCR(fac_ocr,data,[]);
      if (resultValidaciones.message === FAILED_VALIDATION) {
        toast.current?.show({
          life: LIFE_TOAST_MESSAGE,
          severity: "warn",
          summary: "Mensaje",
          detail: "No se pasaron las validaciones, revise manualmente",
        });
        setmostrarFormComprobante(true);
        setIngresoManual(true);
        setLecturaOCR('error');
        return;
      }
      else {
        setmostrarFormComprobante(true);
        setMessage({
          life: 5000,
          severity: "success",
          summary: "Mensaje",
          detail: "Lectura Completa.",
        });
        setLecturaOCR('success');
      }

    }
    setmostrarCargaComprobante(false);
  };

  const setiibbconfig = () =>{
        let jurisdiccionesIngreso: any[] | ((prevState: IngresoJurisdiccion[]) => IngresoJurisdiccion[]) = []
        if (jurisdiccionesConfig && jurisdiccionesConfig.length > 0) {
              const jurisdiccionesFormateadas = jurisdiccionesConfig.map((config: any) => {
                const jurisdiccionCompleta = jurisdicciones.find(
                  (j: { codigo: any; }) => j.codigo === config.sta_code
                );
                return {
                  jurisdiccion: jurisdiccionCompleta || {
                    sta_code: config.sta_code,
                    descripcion: '' 
                  },
                  monto: 0 
                };
              });
              jurisdiccionesIngreso = jurisdiccionesFormateadas;
              setCollapsedIngresosBrutos(false)
            }
            setIngresosJurisdicciones(jurisdiccionesIngreso);
      // Actualizar Formik con el nuevo total 
      const nuevoTotal = jurisdiccionesIngreso.reduce((sum, item) => sum + item.monto, 0);
      formik.setFieldValue('Fac_IIBB_percepcion', nuevoTotal);
  }

  const validateFacturaData = (data: any) => {
    let errors: any = {};
    
    if (data.fat_descripcion_red.length === 0) {
        errors.fat_descripcion_red = "Requerido.";
      }
      if (!data.fac_tipo_comprobante) {
        errors.comprobante = "Requerido.";
      }
      if (!data.Fac_sucursal) {
        errors.Fac_sucursal = "Requerido.";
      }
      if (!data.Fac_numero) {
        errors.Fac_numero = "Requerido.";
      }
      if (data.Fac_neto == 0 || data.Fac_neto == null) {
        errors.Fac_neto = "Requerido.";
      }
      if (data.Fac_impuestos !== 0) {
        if (!data.Fac_impuestos) {
          errors.Fac_impuestos = "Requerido.";
        }
      }
      if (data.Fac_iva !== 0) {
        if (!data.Fac_iva) {
          errors.Fac_iva = "Requerido.";
        }
      }
      if (data.Fac_total == 0 || data.Fac_total == null) {
        errors.Fac_total = "Requerido.";
      }
      if (data.Fac_tasa_iva.length === 0) {
        errors.Fac_tasa_iva = "Requerido.";
      }
      if (new Date(data.Fecha).setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0)) {
        errors.Fecha = "No puede ser futura.";
      }
      return errors;
  };

  const MapeoFactura_Ocr = (ocr: any) => {
    return {
      fat_descripcion_red: obtenerTipoFa(ocr?.type),
      fac_tipo_comprobante:
      (ocr?.letter && ["A", "B", "C", "M", "E", "T"].includes(ocr.letter)
        ? ocr.letter
        : null) ??
      
      (JSON.stringify(comprobanteSeleccionado ?? {}) !== "{}"
        ? comprobanteSeleccionado?.fac_tipo_comprobante
        : (tasasIVA?.[0]?.tipo_comprobante !== "N"
          ? tasasIVA?.[0]?.tipo_comprobante
          : "A")),

      Fac_sucursal: ocr?.point_Sale ?? comprobanteSeleccionado?.fac_sucursal ?? null,
      Fac_numero: ocr?.number ?? comprobanteSeleccionado?.fac_numero ?? null,

      Fecha: convertirFecha(ocr?.date),

      Fac_neto:
        ocr?.neto != null
          ? toNumberLatam(ocr.neto)
          : 0,


      Fac_impuestos:
        ocr?.itc_Idc_Tasas != null
          ? toNumberLatam(ocr.itc_Idc_Tasas)
          : 0,


      Fac_iva:
        ocr?.iva != null
          ? toNumberLatam(ocr.iva)
          : 0,

      Fac_iva_percepcion:
        ocr?.ivaPerception != null
          ? toNumberLatam(ocr.ivaPerception)
          : 0,


      Fac_IIBB_percepcion: 0,

      Fac_total:
        ocr?.total != null
          ? toNumberLatam(ocr.total)
          : 0,

      Fac_tasa_iva: obtenerIva(ocr?.ivaType,ocr),
    }
  };

  const toNumberLatam = (s: unknown): number => {
    const r = (s ?? "").toString().trim();
    if (!r) return 0;

    let x = r.replace(/[^\d.,-]/g, "");    
    const neg = x.includes("-");
    x = x.replace(/-/g, "");

    const p = Math.max(x.lastIndexOf("."), x.lastIndexOf(","));
    const dec = p >= 0 ? x[p] : null;

    if (dec) {
      const thou = dec === "." ? "," : ".";
      x = x.replace(new RegExp("\\" + thou, "g"), "")     // quita miles
          .replace(new RegExp("\\" + dec, "g"), ".");    // normaliza decimal
    } else {
      x = x.replace(/[.,]/g, ""); // sin separadores → todo miles
    }

    const n = Number(x);
    return Number.isFinite(n) ? (neg ? -n : n) : 0;
  }

  function obtenerIva(ocrType: any,ocr:any): any {
    if (!ocrType) return pickIva(ocr);

    const texto = ocrType.toString().replace(',', '.');
    if (texto.includes('27')){
      return tasasIVA.filter(
            (item: any) => item.tasa == 27
          )[0];
    } 
    if (texto.includes('21')) 
      {
       return tasasIVA.filter(
            (item: any) => item.tasa == 21
        )[0];
        }
    if (texto.includes('10')) {
       return tasasIVA.filter(
            (item: any) => item.tasa == 10
        )[0];
        }
    if (texto.includes('0'))  {
       return tasasIVA.filter(
            (item: any) => item.tasa == 0
        )[0];
        }
      return pickIva(ocr);
  }
  
  function pickIva(ocr: any) {
    const allowed = [0, 10, 21, 27];

    let iva = toNumberLatam(ocr.iva);
    let total = toNumberLatam(ocr.total);
    let neto = toNumberLatam(ocr.neto);
    let otros = toNumberLatam(ocr.itc_Idc_Tasas);
    // Completar faltantes básicos
    if (iva === null && total !== null && neto !== null) {
      iva = total - neto - otros;
    }
    if (neto === null && total !== null && iva !== null) {
      neto = total - iva - otros;
    }

    // Si no se puede calcular, devolvé 21% como fallback (o null)
    if (iva === null || neto === null || !isFinite(iva) || !isFinite(neto) || neto === 0) {
      return tasasIVA.filter(
              (item: any) => item.tasa == 21
          )[0] ?? 0;
    }

    // Tasa cruda y elección del porcentaje permitido más cercano
    const rawPercent = Math.abs(iva) / Math.abs(neto) * 100;
    const nearestPercent = allowed.sort(
      (a, b) => Math.abs(rawPercent - a) - Math.abs(rawPercent - b)
    )[0];

    // Devolver el item correspondiente
    tasasIVA.filter(
              (item: any) => item.tasa == 0
          )[0];
    return tasasIVA.filter(
              (item: any) => item.tasa == nearestPercent
          )[0]?? 0;
  }

  function convertirFecha(fechaStr: string | null | undefined): Date | null {
    if (!fechaStr) return null;

    // Detecta formato dd/MM/yyyy
    const partes = fechaStr.split('/');
    if (partes.length === 3) {
      const [dia, mes, anio] = partes.map(Number);
      if (!isNaN(dia) && !isNaN(mes) && !isNaN(anio)) {
        return new Date(anio, mes - 1, dia);
      }
    }

    const fecha = new Date(fechaStr);
    return isNaN(fecha.getTime()) ? null : fecha;
  }
  function obtenerTipoFa(ocrType: string | null | undefined): any {
    if (!ocrType) return null;
    const texto = ocrType.toLowerCase().trim();
    console.log(tiposFactura)
 
   let tipo =  tiposFactura.filter(
        (item: any) =>
          item.fat_descripcion_corta.toLowerCase().trim() ===
          ocrType.toLowerCase().trim()
      ); 

      if(tipo.length > 0){
        return tipo[0];
      }

    return null;
  }
  const ComprobantesValidacionesOCR = (data: any,ocr:any, iibb:any []) => {
    let facTotal = parseFloat(data.Fac_total);
    let facNeto = parseFloat(data.Fac_neto);
    let facIva = parseFloat(data.Fac_iva);
    let facImpuestos = parseFloat(data.Fac_impuestos);
    let facTasaIva = parseFloat(data.Fac_tasa_iva.tasa);
    let facIvaPercepcion = parseFloat(data.Fac_iva_percepcion);
    let facIIBBPercepcion = parseFloat(data.Fac_IIBB_percepcion);
    let fac_sucursal = data.Fac_sucursal;
    let fac_numero = data.Fac_numero;
    let fecha = data.Fecha;
    let letter = data.fac_tipo_comprobante;
    let message = SUCCESS_VALIDATION;
    
    if (fac_sucursal === null) {
      setobservacionesOCR(observacionesOCR + " - Fallo en lectura de punto de venta ")
      return { message: FAILED_VALIDATION };
    }
    if (fac_numero === null) {
      setobservacionesOCR(observacionesOCR + " - Fallo en lectura de numero ")
      return { message: FAILED_VALIDATION };
    }
    if (fecha === null) {
      setobservacionesOCR(observacionesOCR + " - Fallo en lectura de fecha ")
      return { message: FAILED_VALIDATION };
    }
    
    if(letter !== null && !["A", "B", "C", "M", "E", "T"].includes(letter)){
        setobservacionesOCR(observacionesOCR + " - Fallo en lectura de letra ")
        return { message: FAILED_VALIDATION };
    }

    if(tasaIvaSelected !== null && tasaIvaSelected !== undefined){
          if(facTasaIva !== tasaIvaSelected){
            toast.current?.show({
              life: LIFE_TOAST_MESSAGE,
              severity: "warn",
              summary: "Mensaje",
              detail:
                "No es posible cargar el comprobante.  Debes usar "+ tasaIvaSelected +"% de IVA. Si el comprobante aplica otro IVA, crea una nueva presentación." 
            });
            setobservacionesOCR(observacionesOCR + " - El porcentaje de IVA debe coincidir con el del la presentación.")
            return { message: FAILED_VALIDATION };
          }         
    }

  if(fecha !== null){
    const fechaComprobante = new Date(fecha);
    
    const jurisdiccionesExcluidas = iibb
      .filter(item => {
        if(!item.fechadesde) return false;
        
        const desde = new Date(item.fechadesde);
        const hasta = item.fechahasta ? new Date(item.fechahasta) : null;
        
        return fechaComprobante >= desde && (!hasta || fechaComprobante <= hasta);
      })
      .map(item => item.descripcion);
    
      if(jurisdiccionesExcluidas.length > 0){
        const jurisdicciones = jurisdiccionesExcluidas.join(', ');
        
        toast.current?.show({
          life: LIFE_TOAST_MESSAGE,
          severity: "warn",
          summary: "Exclusión de Percepción",
          detail: `No resulta posible efectuar la percepción en la${jurisdiccionesExcluidas.length > 1 ? 's jurisdicciones' : ' jurisdicción'} ${jurisdicciones} dentro del plazo correspondiente al comprobante, por poseer una exclusión vigente.`,
        });
        return { message: FAILED_VALIDATION };
      }
      
    }
    //ToleranciaTopeIva 23
    let toleranciaTopeIva = parametrosPresentacion.filter((item: ParametroDTO) => item.subcodigo == "ToleranciaTopeIva")
    const TOLERANCIA_TOPE_IVA = Number.isNaN(Number.parseFloat(toleranciaTopeIva[0].valor)) ? 0 : parseFloat(toleranciaTopeIva[0].valor)

    let totalNetoImpuesto = facNeto + facImpuestos;
    if (totalNetoImpuesto < TOLERANCIA_TOPE_IVA && facIvaPercepcion > 0) {
      toast.current?.show({
        life: LIFE_TOAST_MESSAGE,
        severity: "warn",
        summary: "Mensaje",
        detail:
          "Si el neto es menor a $ " +
          TOLERANCIA_TOPE_IVA +
          ", no debe ingresar percepcion de Iva",
      });
      setobservacionesOCR(observacionesOCR + " - Fallo en tolerancia Tope percepcion IVA ")
      return { message: FAILED_VALIDATION };
    }

    //12 $2
    //calcula el 3% del neto y hago la diferencia entre ivapercepcion- porcentajeNeto
    let difIvaPer = parametrosPresentacion.filter((item: ParametroDTO) => item.subcodigo == "DiferenciaPerIvaYCalPercepcion")
    const DIFERENCIAPERIVAYCALPERCEPCION = Number.isNaN(Number.parseFloat(difIvaPer[0].valor)) ? 0 : parseFloat(difIvaPer[0].valor)

    let resultIvaPer = parametrosPresentacion.filter((item: ParametroDTO) => item.subcodigo == "IvaPercepcion")
    const IVA_PERCEPCION = Number.isNaN(Number.parseFloat(resultIvaPer[0].valor)) ? 0 : parseFloat(resultIvaPer[0].valor)
    let porcentajeNeto = Number(facNeto * IVA_PERCEPCION).toFixed(2);
    let diferenciaPerIvaYCalPercepcion = facIvaPercepcion - parseFloat(porcentajeNeto);

    if (Math.abs(diferenciaPerIvaYCalPercepcion) > DIFERENCIAPERIVAYCALPERCEPCION && facIvaPercepcion > 0) {
      toast.current?.show({
        life: LIFE_TOAST_MESSAGE,
        severity: "warn",
        summary: "Mensaje",
        detail:
          "La diferencia permitida entre la percepcion de IVA ingresado y el " +
          IVA_PERCEPCION +
          " % del neto es $" +
          DIFERENCIAPERIVAYCALPERCEPCION +
          ". Total Diferencia: $" +
          formatMoney(diferenciaPerIvaYCalPercepcion),
      });
      setobservacionesOCR(observacionesOCR + " - Percepción IVA requiere validación manual")

      return { message: FAILED_VALIDATION };
    }

    if (facIvaPercepcion > parseFloat(porcentajeNeto) && Math.abs(diferenciaPerIvaYCalPercepcion) > TOLERANCIA_DIF_IVA_PERCEPCION) {
      toast.current?.show({
        life: LIFE_TOAST_MESSAGE,
        severity: "warn",
        summary: "Mensaje",
        detail: `La percepcion supera el ${IVA_PERCEPCION}% del neto`,
      });
      setobservacionesOCR(observacionesOCR + " - Fallo en percepcion IVA supera el % del neto")
      return { message: FAILED_VALIDATION };
    }
    //17 $
    let toleranciaImpTasaFC = parametrosPresentacion.filter((item: ParametroDTO) => item.subcodigo == "ToleranciaImporteTasaCargaFC")
    const TOLERANCIA_IMPORTE_TASA_CARGAFC = Number.isNaN(Number.parseFloat(toleranciaImpTasaFC[0].valor)) ? 0 : parseFloat(toleranciaImpTasaFC[0].valor)

    let ivaCalculado = Number((facNeto * facTasaIva) / 100).toFixed(3);
    let diferenciaImporteTasaCargaFC = Number(parseFloat(ivaCalculado) - facIva).toFixed(2);
    if (Math.abs(parseFloat(diferenciaImporteTasaCargaFC)) > TOLERANCIA_IMPORTE_TASA_CARGAFC) {
      toast.current?.show({
        life: LIFE_TOAST_MESSAGE,
        severity: "warn",
        summary: "Mensaje",
        detail:
          "La diferencia permitida entre el importe de IVA calculado y el importe IVA ingresado es $" +
          formatMoney(TOLERANCIA_IMPORTE_TASA_CARGAFC) +
          ". Total Diferencia: $" +
          formatMoney(diferenciaImporteTasaCargaFC),
      });
      setobservacionesOCR(observacionesOCR + " - IVA requiere validación manual")
      return { message: FAILED_VALIDATION };
    }

    //22 %
    let toleranciaTasaFC = parametrosPresentacion.filter((item: ParametroDTO) => item.subcodigo == "ToleranciaTasaCargaFC")
    const TOLERANCIA_TASA_CARGAFC = Number.isNaN(Number.parseFloat(toleranciaTasaFC[0].valor)) ? 0 : parseFloat(toleranciaTasaFC[0].valor)
    let tasaIvaCalculado = Number((parseFloat(ivaCalculado) * 100) / facNeto);
    let diferenciaTasaIva = tasaIvaCalculado - facTasaIva;
    //Math.abs(x)
    if (Math.abs(diferenciaTasaIva) > TOLERANCIA_TASA_CARGAFC) {
      toast.current?.show({
        life: LIFE_TOAST_MESSAGE,
        severity: "warn",
        summary: "Mensaje",
        detail:
          "La diferencia de porcentaje permitida entre la Tasa de IVA calculada y la Ingresada es % " +
          TOLERANCIA_TASA_CARGAFC +
          ". Total Diferencia: $" +
          formatMoney(diferenciaTasaIva),
      });
      setobservacionesOCR(observacionesOCR + " - IVA calculada vs ingresada requiere validación manual")
      return { message: FAILED_VALIDATION };
    }

    //18 %
    if (isCombustibleAfines(selectedProductoComercio.grupoProductoId)) {

      let toleranciaImpFC = parametrosPresentacion.filter((item: ParametroDTO) => item.subcodigo == "ToleranciaImpuestosCargaFC")
      const TOLERANCIA_IMPUESTOS_CARGAFC = Number.isNaN(Number.parseFloat(toleranciaImpFC[0].valor)) ? 0 : parseFloat(toleranciaImpFC[0].valor)

      let porcentajeImpuestosCargaFC =
        (parseFloat(data.Fac_impuestos) * 100) / parseFloat(data.Fac_neto);
      if (porcentajeImpuestosCargaFC > TOLERANCIA_IMPUESTOS_CARGAFC) {
        toast.current?.show({
          life: LIFE_TOAST_MESSAGE,
          severity: "warn",
          summary: "Mensaje",
          detail:
            "La diferencia de porcentaje permitida entre importe de impuestos con respecto al importe neto es % " +
            TOLERANCIA_IMPUESTOS_CARGAFC +
            " Total Diferencia: %" +
            porcentajeImpuestosCargaFC,
        });
        setobservacionesOCR(observacionesOCR + " - Fallo en diferencia entre impuestos y neto")
        return { message: FAILED_VALIDATION };
      }
    }

    //21 %

    let totalPercepciones = Number(
      facIvaPercepcion + facIIBBPercepcion
    ).toFixed(2);
    let totalNetoEImpuestos = Number(facNeto + facImpuestos).toFixed(2);

    //let totalImpuestos = Number(neto + iva + impuestos)
    //let tasaPercepciones = Number((parseFloat(totalPercepciones) * 100)/ parseFloat(totalNetoEImpuestos)).toFixed(2)
    let toleranciaPercepciones = parametrosPresentacion.filter((item: ParametroDTO) => item.subcodigo == "ToleranciaPercepciones")
    const TOLERANCIA_PERCEPCIONES = Number.isNaN(Number.parseFloat(toleranciaPercepciones[0].valor)) ? 0 : parseFloat(toleranciaPercepciones[0].valor)


    let tasaPercepciones = Number(
      (parseFloat(totalPercepciones) * 100) / parseFloat(totalNetoEImpuestos)
    ).toFixed(2);

    if (parseFloat(tasaPercepciones) / 100 > TOLERANCIA_PERCEPCIONES) {
      toast.current?.show({
        life: LIFE_TOAST_MESSAGE,
        severity: "warn",
        summary: "Mensaje",
        detail:
          "La diferencia permitida entre percepciones con respecto al neto mas impuestos es % " +
          TOLERANCIA_PERCEPCIONES +
          " Total Diferencia: % " +
          formatMoney(tasaPercepciones),
      });
      setobservacionesOCR(observacionesOCR + " - Fallo en diferencia entre percepciones y neto")
      return { message: FAILED_VALIDATION };
    }

    //20 $
    //validaciones
    //consultar diego decimal valor_total = Math.Round(neto + iva + impuesto + ivaPercepcion + iibbPercep + redondeo, 2);
    let tolMontoCargaFC = parametrosPresentacion.filter((item: ParametroDTO) => item.subcodigo == "ToleranciaMontoCargaFC")
    const TOLERANCIA_MONTO_CARGAFC = Number.isNaN(Number.parseFloat(tolMontoCargaFC[0].valor)) ? 0 : parseFloat(tolMontoCargaFC[0].valor)

    let totalImpuestos = Number(
      facNeto + facIva + facImpuestos + facIvaPercepcion + facIIBBPercepcion
    ).toFixed(2);
    let ToleranciaMontoCargaFC = Number(facTotal - parseFloat(totalImpuestos));
    if (Math.abs(ToleranciaMontoCargaFC) > TOLERANCIA_MONTO_CARGAFC) {
      toast.current?.show({
        life: LIFE_TOAST_MESSAGE,
        severity: "warn",
        summary: "Mensaje",
        detail:
          "La diferencia permitida entre el total facturado y el neto mas iva e impuestos es $" +
          formatMoney(TOLERANCIA_MONTO_CARGAFC) +
          ", " +
          "Total Diferencia: $" +
          formatMoney(ToleranciaMontoCargaFC),
      });
      setobservacionesOCR(observacionesOCR + " - Fallo en diferencia entre total facturado y el neto mas iva e impuestos")
      return { message: FAILED_VALIDATION };
    }

    return { message };

  };

      const normalize = (s:any) =>
      (s || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, " ")
        .trim();

    const cuitOk = (ocr:any, expected:any) => {
      const o = (ocr || "").replace(/\D/g, "");
      const e = (expected || "").replace(/\D/g, "");
      if (!o || !e) return false;
      if (o === e) return true;
      // si comparten al menos 7 dígitos consecutivos → ok
      return longestCommonDigits(o, e) >= 7;
    };

    const longestCommonDigits = (a:any, b:any) => {
      let best = 0;
      for (let i = 0; i < a.length; i++) {
        for (let j = 0; j < b.length; j++) {
          let k = 0;
          while (a[i + k] === b[j + k] && a[i + k] && b[j + k]) k++;
          best = Math.max(best, k);
        }
      }
      return best;
    };

    const razonSocialOk = (ocr:any) => {
      const n = normalize(ocr);
      return n.includes("edenred"); // si aparece la palabra clave ya valida
    };

    const direccionOk = (ocr:any) => {
      const o = normalize(ocr).split(" ");
      const esperada = ["esteban", "echeverria", "4150", "munro", "1605", "alferez", "hipólito", "bouchard", "4169"]; 
      let hits = esperada.filter(t => o.includes(t)).length;
      return hits >= 2; // con 2 tokens claves ya la considero buena
    };

    const ComprobantesPreValidacionesOCR = (data:any,fac_ocr:any) => {
      let errores = [];

      if (new Date(fac_ocr.Fecha).setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0)) {
        errores.push("La fecha de la factura no puede ser futura. Verifique la fecha.");
        setobservacionesOCR(observacionesOCR + " - La fecha leida es futura.")
      }

       if(data.iibbPerception && jurisdiccionesConfig.length === 0){
          if(toNumberLatam(data.iibbPerception) > 0){
              setMontoJurisdiccion(toNumberLatam(data.iibbPerception));
              errores.push("Debe cargar manualmente las jurisdicciones de ingresos brutos, el monto es de $" + data.iibbPerception );
              setobservacionesOCR(observacionesOCR + " - No se pudo identificar la jurisdicción de IIBB.")
              setCollapsedIngresosBrutos(false)
            }         
      }

      if (data.cae == null) {
        setsinCAE(true);
        errores.push("La factura no tiene CAE");
        setobservacionesOCR(observacionesOCR + " - La factura no tiene CAE")
      }

      // CUIT 
      if (data.cuitInvoiced != null) {
        if (!cuitOk(data.cuitInvoiced, "30-62360867-7")) {
          errores.push("CUIT incorrecto");
          setobservacionesOCR(observacionesOCR + " - CUIT incorrecto")
        }
      }

      // Razón social 
      if (data.razonSocial != null) {
        if (!razonSocialOk(data.razonSocial)) {
          errores.push("Razón social incorrecta");
          setobservacionesOCR(observacionesOCR + " - Razón social incorrecta")
        }
      }

      // Dirección 
      if (data.direccion != null) {
        if (!direccionOk(data.direccion)) {
          errores.push("Dirección incorrecta");
          setobservacionesOCR(observacionesOCR + " - Dirección incorrecta")
        }
      }
      // Productos
      if (isCombustibleAfines(selectedProductoComercio.grupoProductoId) && !data.productosOk) {
        errores.push("Productos incorrectos");
        setobservacionesOCR(observacionesOCR + " - Productos incorrectos")
      }
      // tasa iva
      if(tasaIvaSelected !== null && tasaIvaSelected !== undefined){
          if(parseFloat(fac_ocr.Fac_tasa_iva.tasa) !== tasaIvaSelected){
            errores.push("Debes usar "+ tasaIvaSelected +"% de IVA. Si el comprobante aplica otro IVA, crea una nueva presentación." );
            setobservacionesOCR(observacionesOCR + " - Debes usar "+ tasaIvaSelected +"% de IVA. Si el comprobante aplica otro IVA, crea una nueva presentación.")
          }         
        }
      if (errores.length > 0) {
        return { listErrores: errores };
      } else {
        return { listErrores: errores };
      }
    };

    const agregarIIBBporJuridisccion= (data:any)=>{
      let nuevosIngresos : any[] = ingresosJurisdicciones;
      const tieneBSAS = data.iibbPerceptionBSAS && data.iibbPerceptionBSAS !== "";
      const tieneCABA = data.iibbPerceptionCABA && data.iibbPerceptionCABA !== "";
      const tieneGenerico = data.iibbPerception && data.iibbPerception !== "";
      
      if (tieneBSAS) {
        const jurisdiccionAires = jurisdicciones.find(
          (j: { descripcion: string }) => {
            const desc = j.descripcion.toLowerCase();
            return desc.includes('aires') || desc.includes('buenos');
          }
        );
        const nueva = {
          jurisdiccion: jurisdiccionAires,
          monto: toNumberLatam(data.iibbPerceptionBSAS)
        };
        nuevosIngresos = [...nuevosIngresos, nueva];
        setCollapsedIngresosBrutos(false)
      }
      
      if (tieneCABA) {
        const jurisdiccionCABA = jurisdicciones.find(
          (j: { descripcion: string }) => {
            const desc = j.descripcion.toLowerCase();
            return desc.includes('caba') || desc.includes('capital federal');
          }
        );
        const nueva = {
          jurisdiccion: jurisdiccionCABA,
          monto: toNumberLatam(data.iibbPerceptionCABA)
        };
        nuevosIngresos = [...nuevosIngresos, nueva];
        setCollapsedIngresosBrutos(false);
      }
      
      if (!tieneBSAS && !tieneCABA && tieneGenerico) {
        const montoGenerico = toNumberLatam(data.iibbPerception);
        
        if (montoGenerico > 0 && jurisdiccionesConfig && jurisdiccionesConfig.length === 1) {
          const jurisdiccionCompleta = jurisdicciones.find(
            (j: { codigo: any }) => j.codigo === jurisdiccionesConfig[0].sta_code
          );
          
          if (jurisdiccionCompleta) {
            const nueva = {
              jurisdiccion: jurisdiccionCompleta,
              monto: montoGenerico
            };
            nuevosIngresos = [...nuevosIngresos, nueva];
            setCollapsedIngresosBrutos(false);
          }
        }else{
            if (jurisdiccionesConfig && jurisdiccionesConfig.length > 0) {
              const jurisdiccionesFormateadas = jurisdiccionesConfig.map((config: any) => {
                const jurisdiccionCompleta = jurisdicciones.find(
                  (j: { codigo: any; }) => j.codigo === config.sta_code
                );
                return {
                  jurisdiccion: jurisdiccionCompleta || {
                    sta_code: config.sta_code,
                    descripcion: '' 
                  },
                  monto: 0 
                };
              });
              nuevosIngresos = jurisdiccionesFormateadas;
              setCollapsedIngresosBrutos(false)
            }
        }
      }
      setIngresosJurisdicciones(nuevosIngresos);
      // Actualizar Formik con el nuevo total 
      const nuevoTotal = nuevosIngresos.reduce((sum, item) => sum + item.monto, 0);
      formik.setFieldValue('Fac_IIBB_percepcion', nuevoTotal);
      return nuevoTotal;  
    }
  return (
    <>
    <div className="form-demo comprobantes">
      <Toast ref={toast} position="bottom-right" />
      <form onSubmit={formik.handleSubmit} className="flex p-fluid justify-content-center">
        {/* formulario */}
        {(mostrarFormComprobante || 
        (JSON.stringify(comprobanteSeleccionado) !== "{}" )) 
        &&(
        <Card
          subTitle={() => subtitleCard("DATOS DE COMPROBANTE")}
          className="p-mb-2"
        >
          <div className="p-grid p-fluid  p-align-baseline comprobantes-grid-datos-generales">
            <div className="p-col-12 p-md-3">
              <div className="field">
                <span className="p-float-label">
                  <Dropdown
                    onKeyDown={(e) => handlerEnterKey(e, false, compRefs.puntoVenta)}
                    id="fat_descripcion_red"
                    name="fat_descripcion_red"
                    value={formik.values.fat_descripcion_red}
                    onChange={formik.handleChange}
                    options={tiposFactura}
                    optionLabel="fat_descripcion"
                    disabled={!presentacionEditable || !ingresoManual}
                  appendTo="self"

                  />
                  <label htmlFor="fat_descripcion_red">Tipo*</label>
                </span>
                {getFormErrorMessage("fat_descripcion_red")}
              </div>
            </div>
            <div className="p-col-12 p-md-2">
              <div className="field">
                <span className="p-float-label">
                  <InputText
                    id="fac_tipo_comprobante"
                    name="fac_tipo_comprobante"
                    value={formik.values.fac_tipo_comprobante}
                    onChange={formik.handleChange}
                    disabled={true}
                    className={classNames({
                      "p-invalid": isFormFieldValid("fac_tipo_comprobante"),
                    })}
                  />
                  <label
                    htmlFor="fac_tipo_comprobante"
                    className={classNames({
                      "p-error": isFormFieldValid("fac_tipo_comprobante"),
                    })}
                  >
                    Letra
                  </label>
                </span>
                {getFormErrorMessage("fac_tipo_comprobante")}
              </div>
            </div>
            <div className="p-col-12 p-md-2">
              <div className="field">
                <span className="p-float-label">
                  <InputText
                    onKeyDown={(e) => handlerEnterKey(e, false, compRefs.numero)}
                    ref={compRefs.puntoVenta}
                    id="Fac_sucursal"
                    name="Fac_sucursal"
                    value={formik.values.Fac_sucursal}
                    onChange={formik.handleChange}
                    autoFocus
                    disabled={!presentacionEditable || !ingresoManual}
                    className={classNames({
                      "p-invalid": isFormFieldValid("Fac_sucursal"),
                    })}
                  />
                  <label
                    htmlFor="Fac_sucursal"
                    className={classNames({
                      "p-error": isFormFieldValid("Fac_sucursal"),
                    })}
                  >
                    Punto de venta*
                  </label>
                </span>
                {getFormErrorMessage("Fac_sucursal")}
              </div>
            </div>
            <div className="p-col-12 p-md-2">
              <div className="field">
                <span className="p-float-label">
                  <InputText
                    onKeyDown={(e) => handlerEnterKey(e, false, compRefs.fecha)}
                    ref={compRefs.numero}
                    id="Fac_numero"
                    name="Fac_numero"
                    value={formik.values.Fac_numero}
                    onChange={formik.handleChange}
                    disabled={!presentacionEditable || !ingresoManual}
                    className={classNames({
                      "p-invalid": isFormFieldValid("Fac_numero"),
                    })}
                  />
                  <label
                    htmlFor="Fac_numero"
                    className={classNames({
                      "p-error": isFormFieldValid("Fac_numero"),
                    })}
                  >
                    Numero*
                  </label>
                </span>
                {getFormErrorMessage("Fac_numero")}
              </div>
            </div>

            <div className="p-col-12 p-md-3">
              <div className="field">
                <span className="p-float-label">
                  <Calendar
                    inputRef={compRefs.fecha}
                    onSelect={e => handlerEnterKey({ key: ENTER_KEY, preventDefault: () => { }, stopPropagation: () => { } }, false, compRefs.neto)}
                    id="Fecha"
                    name="Fecha"
                    value={formik.values.Fecha}
                    onChange={formik.handleChange}
                    dateFormat="dd/mm/yy"
                    mask="99/99/9999"
                    showIcon
                    disabled={!presentacionEditable || !ingresoManual}
                    maxDate={new Date()}
                    className={classNames({
                        "p-invalid": isFormFieldValid("Fecha"),
                      })}
                  />
                  <label htmlFor="Fecha">Fecha</label>
                   {getFormErrorMessage("Fecha")}  
                </span>
              </div>
            </div>
          </div>
        </Card>
        )}
        {(mostrarFormComprobante || 
        (JSON.stringify(comprobanteSeleccionado) !== "{}"))
          // ||(presentacionState !== INICIADA_COMERCIO && presentacionState !== RECHAZADA)
        &&(
        <Card subTitle={() => subtitleCard("DETALLE")} className="p-mb-2 pb-0">
          <div className="p-grid p-align-baseline comprobantes-grid-impuestos pb-0">
            <div className="p-grid p-col p-lg-10 p-md-12 p-sm-8">
              <div className="p-p-2 p-col p-lg-2 p-md-4 p-sm-6" >
                <div className="field">
                  <span className="p-float-label">
                    <InputNumber
                      onKeyDown={(e) => handlerEnterKey(e, false, compRefs.tasas)}
                      inputRef={compRefs.neto}
                      id="Fac_neto"
                      name="Fac_neto"
                      value={formik.values.Fac_neto}
                      onValueChange={(e) =>
                        formik.setFieldValue("Fac_neto", e.value)
                      }
                      mode="decimal"
                      minFractionDigits={2}
                      min={0}
                    disabled={!presentacionEditable || !ingresoManual}
                      className={classNames({
                        "p-invalid": isFormFieldValid("Fac_neto"),
                      })}
                    />

                    <label
                      htmlFor="Fac_neto"
                      className={classNames({
                        "p-error": isFormFieldValid("Fac_neto"),
                      })}
                    >
                      Neto*
                    </label>
                  </span>
                  {getFormErrorMessage("Fac_neto")}
                </div>
              </div>
              <div className="p-p-2 p-col p-lg-2 p-md-4 p-sm-6">
                <div className="field">
                  <span className="p-float-label">
                    <InputNumber
                      onKeyDown={(e) => handlerEnterKey(e, false, compRefs.iva_inp)}
                      inputRef={compRefs.tasas}
                      id="Fac_impuestos"
                      name="Fac_impuestos"
                      value={formik.values.Fac_impuestos}
                      onValueChange={(e) =>
                        formik.setFieldValue("Fac_impuestos", e.value)
                      }
                      mode="decimal"
                      minFractionDigits={2}
                      min={0}
                    disabled={!presentacionEditable || !ingresoManual}
                      className={classNames({
                        "p-invalid": isFormFieldValid("Fac_impuestos"),
                      })}
                    />
                    <label
                      htmlFor="Fac_impuestos"
                      className={classNames({
                        "p-error": isFormFieldValid("Fac_impuestos"),
                      })}
                    >
                      {isCombustibleAfines(selectedProductoComercio.grupoProductoId)
                        ? "ITC/IDC/Tasas*"
                        : "Neto No Gravado*"}
                    </label>
                  </span>
                  {getFormErrorMessage("Fac_impuestos")}
                </div>
              </div>
              <div className="p-p-2 p-col p-lg-2 p-md-4 p-sm-6">
                <div className="field">
                  <span className="p-float-label">
                    <InputNumber
                      onKeyDown={(e) => handlerEnterKey(e, false, compRefs.iva_perc)}
                      inputRef={compRefs.iva_inp}
                      id="Fac_iva"
                      name="Fac_iva"
                      value={formik.values.Fac_iva}
                      onValueChange={(e) =>
                        formik.setFieldValue("Fac_iva", e.value)
                      }
                      mode="decimal"
                      minFractionDigits={2}
                      min={0}
                    disabled={!presentacionEditable || !ingresoManual}
                      className={classNames({
                        "p-invalid": isFormFieldValid("Fac_iva"),
                      })}
                    />
                    <label
                      htmlFor="Fac_iva"
                      className={classNames({
                        "p-error": isFormFieldValid("Fac_iva"),
                      })}
                    >
                      IVA*
                    </label>
                  </span>
                  {getFormErrorMessage("Fac_iva")}
                </div>
              </div>
              <div className="p-p-2 p-col p-lg-2 p-md-4 p-sm-6">
                <div className="field">
                  <span className="p-float-label">
                    <InputNumber
                      onKeyDown={(e) => handlerEnterKey(e, false, compRefs.ibb)}
                      inputRef={compRefs.iva_perc}
                      id="Fac_iva_percepcion"
                      name="Fac_iva_percepcion"
                      value={formik.values.Fac_iva_percepcion}
                      onValueChange={(e) =>
                        formik.setFieldValue("Fac_iva_percepcion", e.value)
                      }
                      mode="decimal"
                      minFractionDigits={2}
                      min={0}
                    disabled={!presentacionEditable || !ingresoManual}
                      className={classNames({
                        "p-invalid": isFormFieldValid("Fac_iva_percepcion"),
                      })}
                    />
                    <label
                      htmlFor="Fac_iva_percepcion"
                      className={classNames({
                        "p-error": isFormFieldValid("Fac_iva_percepcion"),
                      })}
                    >
                      IVA percepción*
                    </label>
                  </span>
                  {getFormErrorMessage("Fac_iva_percepcion")}
                </div>
              </div>
              <div className="p-p-2 p-col p-lg-2 p-md-4 p-sm-6">
                <div className="field"
                onClick={() => setCollapsedIngresosBrutos(false)}
                >
                  <span className="p-float-label">
                    <InputNumber
                      onKeyDown={(e) => handlerEnterKey(e, false, compRefs.total)}
                      inputRef={compRefs.ibb}
                      id="Fac_IIBB_percepcion"
                      name="Fac_IIBB_percepcion"
                      value={formik.values.Fac_IIBB_percepcion}
                      onValueChange={(e) =>
                        formik.setFieldValue("Fac_IIBB_percepcion", e.value)
                      }
                      mode="decimal"
                      minFractionDigits={2}
                      min={0}
                      disabled={true}
                      className={classNames({
                        "p-invalid": isFormFieldValid("Fac_IIBB_percepcion"),
                      })}
                    />
                    <label
                      htmlFor="Fac_IIBB_percepcion"
                      className={classNames({
                        "p-error": isFormFieldValid("Fac_IIBB_percepcion"),
                      })}
                    >
                      IIBB percepción*
                    </label>
                  </span>
                  {getFormErrorMessage("Fac_IIBB_percepcion")}
                </div>
              </div>
              <div className="p-p-2 p-col p-lg-2 p-md-4 p-sm-6">
                <div className="field">
                  <span className="p-float-label">
                    <InputNumber
                      onKeyDown={(e) => handlerEnterKey(e, false, compRefs.iva_dropdw)}
                      inputRef={compRefs.total}
                      id="Fac_total"
                      name="Fac_total"
                      value={formik.values.Fac_total}
                      onValueChange={(e) =>
                        formik.setFieldValue("Fac_total", e.value)
                      }
                      mode="decimal"
                      minFractionDigits={2}
                      min={0}
                      disabled={!presentacionEditable || !ingresoManual}
                      className={classNames({
                        "p-invalid": isFormFieldValid("Fac_total"),
                      })}
                    />
                    <label
                      htmlFor="Fac_total"
                      className={classNames({
                        "p-error": isFormFieldValid("Fac_total"),
                      })}
                    >
                      Total*
                    </label>
                  </span>
                  {getFormErrorMessage("Fac_total")}
                </div>
              </div>
              
            </div>
            <div className="p-p-2 p-col p-lg-2 p-md-2 p-sm-4">
              <div className="field">
                <span className="p-float-label drop-arrow">
                  <Dropdown
                    onKeyDown={(e) => handlerEnterKey(e, true, null)}
                    ref={compRefs.iva_dropdw}
                    id="Fac_tasa_iva"
                    name="Fac_tasa_iva"
                    value={formik.values.Fac_tasa_iva}
                    onChange={formik.handleChange}
                    options={
                     tasaIvaSelected !== null && tasaIvaSelected !== undefined
                        ? tasasIVA.filter(
                          (item: any) => item.tasa == tasaIvaSelected
                        )
                        : tasasIVA
                    }
                    optionLabel="tasa"
                    valueTemplate={(option) => {
                        // Solo interceptar cuando el valor es 0
                        if (option === 0 || option?.tasa === 0) {
                          return '0';
                        }
                        return option?.tasa ?? option;
                      }}  
                    disabled={!presentacionEditable || !ingresoManual}
                    appendTo="self"
                  />
                  <label htmlFor="Fac_tasa_iva">IVA % </label>
                </span>
                {getFormErrorMessage("Fac_tasa_iva")}
              </div>
            </div>
          </div>
          {JSON.stringify(comprobanteSeleccionado) === "{}"  &&(
              <div className="p-col-12 pb-0">
                              {lecturaOCR === 'error' && (
                                <div className="scan-alert scan-alert--error" style={{ color: "red" }}>
                                  <i className="pi pi-exclamation-triangle scan-alert__icon" aria-hidden />
                                  <span className="scan-alert__text">
                                    <strong>Uno o más campos no pudieron leerse correctamente.</strong>
                                    &nbsp;Por favor, te pedimos que ingreses de manera manual el dato faltante.
                                  </span>
                                </div>
                              )}

                              {lecturaOCR === 'warning' && (
                                <div className="scan-alert scan-alert--warning" style={{ color: "orange" }}>
                                  <i className="pi pi-exclamation-circle scan-alert__icon" aria-hidden />
                                  <span className="scan-alert__text">
                                    <strong>Lectura satisfactoria.</strong>
                                    &nbsp;Por favor, validá que los datos sean correctos antes de continuar.
                                  </span>
                                </div>
                              )}

                              {lecturaOCR === 'success' && (
                                <div className="scan-alert scan-alert--ok" style={{ color: "green" }}>
                                  <i className="pi pi-check scan-alert__icon" aria-hidden />
                                  <span className="scan-alert__text">
                                    <strong>Lectura de comprobante satisfactoria.</strong>
                                    &nbsp;Por favor, te pedimos confirmes la carga del mismo.
                                  </span>
                                </div>
                              )}
                              </div>
          )}
                
        </Card>)}
       {/* DETALLE DE INGRESOS BRUTOS */}
        {(mostrarFormComprobante || (JSON.stringify(comprobanteSeleccionado) !== "{}"))
        &&(
         <Card className="card-collapsible">
                <div 
                  className="card-collapsible-header"
                  onClick={() => setCollapsedIngresosBrutos(!collapsedIngresosBrutos)}
                >
                  <span>DETALLE DE INGRESOS BRUTOS</span>
                  <Button
                    icon={`pi ${collapsedIngresosBrutos ? 'pi-chevron-down' : 'pi-chevron-up'}`}
                    type="button"
                    className="p-button-rounded p-button-text p-button-plain"
                    onClick={(e) => {
                      e.stopPropagation();
                      setCollapsedIngresosBrutos(!collapsedIngresosBrutos);
                    }}
                  />
                </div>
                
                {!collapsedIngresosBrutos && (
                  <div className="card-collapsible-content">
                  {/* Formulario para agregar jurisdicción */}
                    {presentacionEditable && ingresoManual
                    && (<div className="p-grid p-align-center">
                      <div className="p-col-12 p-md-5">
                        <Dropdown
                          value={selectedJurisdiccion}
                          options={jurisdicciones}
                          onChange={(e) => setSelectedJurisdiccion(e.value)}
                          optionLabel="descripcion"
                          placeholder="Seleccionar jurisdicción"
                          className="p-w-full"
                          appendTo="self"
                        />
                      </div>
                      <div className="p-col-12 p-md-5">
                        <InputNumber
                          value={montoJurisdiccion}
                          onValueChange={(e) => setMontoJurisdiccion(e.value)}
                          mode="decimal"
                          minFractionDigits={2}
                          maxFractionDigits={2}
                          placeholder="Monto"
                          className="p-w-full"
                        />
                      </div>
                      <div className="p-col-12 p-md-2">
                        <Button
                          label="Agregar"
                          type="button"
                          onClick={handleAgregarJurisdiccion}
                          className="p-w-full"
                        >
                        </Button>
                      </div>
                    </div>)}
        
                    {/* Listado de jurisdicciones agregadas */}
                    {ingresosJurisdicciones.length > 0 && (
                      <DataTable 
                      value={ingresosJurisdicciones} 
                      className="p-mt-3"
                      stripedRows
                      responsiveLayout="scroll"
                    >
                      <Column 
                        field="jurisdiccion.descripcion" 
                        header="Jurisdicción"
                        style={{ width: '50%' }}
                      />
                      <Column 
                        field="monto" 
                        header="Monto" 
                        body={montoBodyTemplate}
                        style={{ textAlign: 'right', width: '30%' }}
                        headerStyle={{ textAlign: 'right' }}
                      />
                      {presentacionEditable && ingresoManual && (
                        <Column
                          header="Acciones"
                          body={(rowData, props) => (buttonsBodyTemplate(props.rowIndex))}
                          style={{ textAlign: 'center', width: '20%' }}
                          headerStyle={{ textAlign: 'center' }}
                        />
                      )}
                    </DataTable>
                    )}
                  </div>
                )}
              </Card>
                )}
       
        {/* carga del archivo */}
         {!mostrarFormComprobante && !mostrarCargaComprobante 
          && (presentacionState === INICIADA_COMERCIO || presentacionState === RECHAZADA ||presentacionState === INGRESADO
            || presentacionState === GENERADO || presentacionState === PAGADO || presentacionState === TRANSFERIDO)
          &&(
        <Card
          className="comprobante-fileupload p-0"
        >
          { JSON.stringify(comprobanteSeleccionado) === "{}" &&(
          <div className="data-scan-text p-0">
            <h4 className="data-scan-title">DATA SCAN</h4>
              <p>
                Adjuntá los comprobantes del lote a presentar para realizar la carga
                automática de los datos.
              </p>

              <p>
                Recordá revisar los siguientes aspectos para realizar una lectura del
                comprobante correcta y rápida:
              </p>

              <ul>
                <li>Los archivos no pueden pesar más de 5&nbsp;MB.</li>
                <li>Cargá un comprobante por archivo.</li>
                <li>
                  Comprobá que sean legibles los comprobantes. En caso de no serlo,
                  recomendamos revisar los niveles de tinta de las impresoras.
                </li>
                <li>
                  Asegurate de que los archivos a cargar estén guardados en alguno de los
                  siguientes formatos: <strong>.JPG</strong>, <strong>.PNG</strong>, <strong>.PDF</strong>.
                </li>
              </ul>

            </div>
          )}
         
          <ComprobanteFileUpload />
        </Card>
        )}
        {mostrarCargaComprobante &&(
        <Card>
            <div
                  style={{
                    padding: '32px 24px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center'
                  }}
                >
                  <img
                    src={ScanOCR}         
                    alt="Ícono lectura de comprobante"
                    style={{ width: 110, height: 110, objectFit: 'contain', marginBottom: 16 }}
                  />

                  <h3
                    style={{
                      margin: '8px 0 6px',
                      fontSize: '1.125rem',
                      fontWeight: 700,
                      color: '#3a3a3a'
                    }}
                  >
                    Leyendo comprobante...
                  </h3>

                  <p
                    style={{
                      margin: 0,
                      color: '#5a5a5a',
                      fontSize: '0.95rem',
                      lineHeight: 1.45,
                      maxWidth: '42ch',
                      minHeight: '3em',
                      transition: 'opacity 0.3s ease-in-out'
                    }}
                  >
                    {mensajesOCR[mensajeActualIndex]}
                  </p>
                </div>

        </Card>
        )}
        <Divider />
        {presentacionEditable && !mostrarCargaComprobante  &&(
          <div className="p-grid p-fluid  p-align-baseline p-jc-end">
            <div className="p-col-12 p-md-3">
              <div className="button-demo">
                <div className="template">
                  <Button
                    type="button"
                    className="discord p-0"
                    aria-label="Discord"
                    style={{ minWidth: "150px" }}
                    onClick={() => props.onHide()}
                  >
                    <i className="pi pi-times px-2"></i>
                    <span className="px-3">Cancelar</span>
                  </Button>
                </div>
              </div>
            </div>

              {mostrarFormComprobante && !ingresoManual&&(
            <div className="p-col-12 p-md-3">
              <div className="button-demo">
                <div className="template">
                  <Button
                    type="button"
                    className="amazon p-0"
                    aria-label="amazon"
                    style={{ minWidth: "150px" }}
                    onClick={() => setIngresoManual(true)}
                  >
                    <i className="pi pi-times px-2"></i>
                    <span className="px-3">Editar</span>
                  </Button>
                </div>
              </div>
            </div>)}

            {ingresoManual &&(
            <div className="p-col-12 p-md-3">
              <div className="button-demo">
                <div className="template">
                  <Button
                    className={`vimeo p-0 ${spinnerGuardarComprobante ? 'p-focus' : ''}`}
                    aria-label="vimeo"
                    type="submit"
                    onSubmit={e => formik.handleSubmit()}
                    style={{ 
                    minWidth: "150px",
                    ...(spinnerGuardarComprobante && {
                      background: '#76db9b',
                      borderColor: 'var(--green-300)'
                    })
                  }}
                   disabled={spinnerGuardarComprobante}  
                    >
                      {spinnerGuardarComprobante ? (
                        <>
                        <i className="pi pi-spin pi-spinner px-2" style={{ color: 'inherit' ,background: '#76db9b'}}></i>
                          <span className="px-3">Guardando...</span>
                        </>
                      ) : (
                        <>
                          <i className="pi pi-check px-2"></i>
                          <span className="px-3">Guardar</span>
                        </>
                      )}
                  </Button>
                </div>
              </div>
            </div>)}
             {!mostrarFormComprobante && fileName && file &&(
              <div className="p-col-12 p-md-3">
                <div className="button-demo">
                  <div className="template">
                    <Button
                      className="twitter p-0"
                      aria-label="Twitter"
                      type="submit"
                      onClick={LeerFacturaPresentacion}
                      style={{ minWidth: "150px" , background: 'linear-gradient(90deg, #F72717 0%, #FF007D 100%)' }}
                    >                  
                        <img
                          src={ScanOCR_ERROR}
                          alt="DataScan"
                          title="DataScan"
                          style={{ width: 38, height: 38, objectFit: "contain", verticalAlign: "middle" }}
                          />
                    <span className="px-3">Iniciar Data Scan</span>
                    </Button>
                  </div>
                </div>
              </div>)}
            {mostrarFormComprobante && !ingresoManual && (
            <div className="p-col-12 p-md-3">
              <div className="button-demo">
                <div className="template">
                  <Button
                    className={`vimeo p-0 ${spinnerGuardarComprobante ? 'p-focus' : ''}`}
                    aria-label="vimeo"
                    type="submit"
                    onSubmit={e => formik.handleSubmit()}
                    style={{ 
                    minWidth: "150px",
                    ...(spinnerGuardarComprobante && {
                      background: '#76db9b',
                      borderColor: 'var(--green-300)'
                    })
                  }}
                  >
                   {spinnerGuardarComprobante ? (
                          <>
                        <i className="pi pi-spin pi-spinner px-2" style={{ color: 'inherit' ,background: '#76db9b'}}></i>
                        <span className="px-3">Confirmando...</span>
                      </>
                    ) : (
                      <>
                        <i className="pi pi-check px-2"></i>
                        <span className="px-3">Confirmar</span>
                      </>
                    )}
                  </Button>
                </div>
              </div>
            </div>)}
          </div>
        )}
      </form>
    </div>
    
    <div className="dialog-demo">
          <ComprobantesModalPreValidacionesOCR
              open={modalOpen}
              message={mensaje}
              onIngresarManual={() => {
                setModalOpen(false);
                setIngresoManual(true);
                setmostrarFormComprobante(true);
              }}
              onVolverACargar={() => {
                setModalOpen(false);
                setFile(null);
                setFileName(null);
                setmostrarFormComprobante(false);
                setIngresoManual(false);
              }}/> 

      </div>      
         
    </>

  );
};
